import $ from 'jquery';

export default function (params) {

	let $widget = $('.js_widget'),
		$from = $('[name=from]', $widget),
		$to = $('[name=to]', $widget),
		$replaceAirport = $('#replace-airport', $widget),

		$passAd = $('[name=ad]', $widget),
		$passYa = $('[name=ya]', $widget),
		$passCh = $('[name=ch]', $widget),
		$passInf = $('[name=inf]', $widget),
		$cabin = $('[name=cabin]', $widget),

		$depDate = $('[name=depDate]', $widget),
		$retDate = $('[name=retDate]', $widget),

		$btnsubmit = $(params.btnSelect, $widget);

	/**
	 * metod get Airport
	 */
	function getAirport() {
		let from = $from.val(),
			to = $to.val();

		if ($replaceAirport.prop('checked')) {
			from = to;
			to = $from.val();
		}

		return {
			from: from,
			to: to
		}
	}
	/**
	 * metod transform  Date
	 */
	function transformDate(currentDate) {
		let m = currentDate.split('/'),
			regex = /(\d\d)$/g,
			y = regex.exec(m[0]);

		return m[2] + '/' + m[1] + '/' + y[0];
	}
	/**
	 * metod getParams
	 */
	function getParams() {
		let air = getAirport(),
			ad = parseInt($passAd.val(), 10),
			ya = parseInt($passYa.val(), 10),
			ch = parseInt($passCh.val(), 10),
			inf = parseInt($passInf.val(), 10),
			summa = ad + ya + ch + inf;

		params = {
			eId: $widget.data('eld'),
			from: air.from,
			to: air.to,
			ad: ad,
			ya: ya,
			ch: ch,
			inf: inf,
			cabin: $cabin.filter(":checked").val(),
			depDate: transformDate($depDate.val()),
			retDate: transformDate($retDate.val()),
			myDatesAreFixedSelected: $widget.data('arefixedselected'),
			restrictionType: $widget.data('restrictiontype'),
			journeyType: $widget.data('journeytype')
		}

		return params;
	}

	/**
	 * metod getUrl
	 */
	function getUrl() {
		let params = getParams();

		return $widget.data('url') + '?' + $.param(params, true);

	}

	$btnsubmit.on('click', function () {

		if ($widget.data('target') === '_blank') {
			return window.open(getUrl());
		}
		window.location = getUrl();
	});

}


// WEBPACK FOOTER //
// ./widget/submit-search.js